import script from "./ChildBrandPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChildBrandPage.vue?vue&type=script&setup=true&lang=ts"

import "./ChildBrandPage.vue?vue&type=style&index=0&id=0117a535&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0117a535"]])

export default __exports__